module.exports = __webpack_public_path__ + "static/media/18ECA29.58b23d6e.jpg";